import { render, staticRenderFns } from "./ChatComments.vue?vue&type=template&id=76b62cdf&"
import script from "./ChatComments.vue?vue&type=script&lang=ts&"
export * from "./ChatComments.vue?vue&type=script&lang=ts&"
import style0 from "./ChatComments.vue?vue&type=style&index=0&id=76b62cdf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports